export const getLocalToken = (()=>{
    var key = 'jwt'
    var b = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)");
    var token = sessionStorage.getItem(key)
    //return b ? b.pop() : sessionStorage.getItem(key);
    const returnData = token ? token : b ? b.pop() : ''
    return returnData
})

export const saveLocalToken = ((token)=>{
    var key = 'jwt'
    document.cookie = `${key}=${token}`
    sessionStorage.setItem(key, token);
})

export const isLoggedIn = (() => {
    return getLocalToken() !== ''
})

export const logout = (()=>{
    var key = 'jwt'
    document.cookie = `${key}=`
    sessionStorage.removeItem(key);
})
